<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="name"
          label="Tên tuyến"
          placeholder="Nhập tên tuyến"
          :rules="[$rules.required]"
          outlined
          dense
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="maxStudent"
          :rules="[$rules.required]"
          class="required"
          label="Số học sinh tối đa"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-select
          v-model="status"
          :items="busStatus"
          clear-icon="mdi-close"
          item-text="title"
          item-value="status"
          label="Chọn trạng thái"
          :rules="[$rules.required]"
          outlined
          dense
          clearable
          class="required"
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <AutocompleteDriver
          v-model="driver"
          return-object
          class="required"
          item-text="title"
          item-value="id"
          label="Lái xe"
          :rules="[$rules.required]"
          required
          dense
          outlined
          auto-select-first
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import AutocompleteDriver from '@/components/basic/input/AutocompleteDriver'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteDriver
  },
  props: {
    busData: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapState('constant', ['busStatus'])
  },
  data: () => ({
    name: '',
    status: '',
    driver: '',
    phone: '',
    data: {
      maxStudent: ''
    },
    maxStudent: ''
  }),
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    resetDefault() {
      if (this.busData) {
        this.name = this.busData.name
        this.status = this.busData.status
        this.driver = this.busData.driver
        this.phone = this.busData.phone
        this.maxStudent = this.busData.data.maxStudent
      }
    },
    getData() {
      return {
        name: this.name,
        driver: this.driver,
        phone: this.phone,
        status: this.status,
        data: {
          ...get(this.busData, 'data', {}),
          maxStudent: this.maxStudent
        }
      }
    }
  },
  created() {
    this.resetDefault()
  },
  watch: {
    busData() {
      this.resetDefault()
    }
  }
}
</script>

<style scoped></style>
